export default function isPopupOpen() {
  const first = this.dataGet("conf/popup/show");
  const second = this.dataGet("conf/popup2/show");

  return first || second;
}
